module.exports = __webpack_public_path__ + "static/media/ariplane4.288aa631.jpg";